import React from "react";
import "./../../css/HomeSloganCards.css";

const HomeSloganCards = () => {
  return (
    <div className='home-slogan-cards'>
      {/* left-slogan Column */}
      <div className='left-slogan-column'>
        <div className='left-slogan-content'>
          <span className='left-slogan-text'>
            PS Environmental Services Inc. specializes in air pollution control,
            offering expert maintenance and dust collection solutions for
            industrial facilities across the U.S.
          </span>
          <ul className='list'>
            {[
              "Dust collection system design corrections and airflow optimization.",
              "Routine inspections, troubleshooting, and repairs.",
              "Filter bag and parts supply with fabric selection expertise.",
              "Safety-certified service in hazardous environments.",
            ].map((item) => (
              <ListItem key={item}>{item}</ListItem>
            ))}
          </ul>
        </div>
      </div>

      {/* right-slogan Column */}
      <div className='right-slogan-column'>
        <div className='right-slogan-content'>
          <span className='right-slogan-text'>
            Driving Growth Through User-Centered Enhancing Productivity and
            Revenue
          </span>
          <div className='right-slogan-subcontent'>
            <p className='uppercase-text'>
              Trusted by Customers Around the Globe
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

const ListItem = ({ children }) => {
  return (
    <li className='list-item'>
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='list-icon'
      >
        <path
          d='M8 0.5C7.66563 7.39062 7.39062 7.66563 0.5 8C7.39062 8.33437 7.66563 8.60938 8 15.5C8.33437 8.60938 8.60938 8.33437 15.5 8C8.60938 7.66563 8.33437 7.39062 8 0.5Z'
          fill='white'
        ></path>
      </svg>
      <span className='list-text'>{children}</span>
    </li>
  );
};

export default HomeSloganCards;
